<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">
                    Aditivos do Convênio
                </span>
            </b-card-header>
            <b-card-body>
                <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
                <div>
                    <app-tabela
                        idTabela="tbAditivos"
                        :itens="aditivos"
                        :campos="campos"
                        :itensPorPagina="itensPorPagina"
                        :bordered="false"
                        :small="false">
                    <template slot="dataAditivo" slot-scope="data">
                        <p class="text-left m-0">
                            {{ data.dataAditivo ? $moment(data.dataAditivo).format('DD/MM/YYYY') : '' }}
                        </p>
                    </template>
                    <template slot="aditivo" slot-scope="data">
                        <p class="text-left m-0" v-if="data.tipoAditivo == 1">
                            {{ $moment(data.dataProrrogada).format('DD/MM/YYYY') }}
                        </p>
                        <p class="text-left m-0" v-if="data.tipoAditivo == 2">
                            {{ data.valorAditivo | currency }}
                        </p>
                    </template>
                    <template slot="statusRmDesc" slot-scope="data">
                        <app-status
                            :status="data.statusRmDesc"
                        ></app-status>
                    </template>
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <btn-inserir-aditivo
                                :convenio="convenio"
                                class="mr-2"
                                v-if="permiteInserirAditivo"
                                @atualizarConvenio="$emit('atualizarConvenio')"
                                @exibirErro="exibirErro($event)"
                            >
                            </btn-inserir-aditivo>
                        </b-button-group>
                    </template>
                    <template slot="acoes" slot-scope="data">
                            <btn-atualizar-aditivo
                                v-if="data.tipoAditivo == 3 || data.tipoAditivo == 4"
                                :convenio="convenio"
                                :aditivo="data"
                                @atualizarLista="atualizarLista()">
                            </btn-atualizar-aditivo>
                            <btn-excluir-aditivo
                                class="text-danger float-left mr-1"
                                v-if="permiteDeletarAditivo(data)"
                                :convenio="convenio"
                                :aditivo="data"
                                @atualizarLista="atualizarLista()"
                            ></btn-excluir-aditivo>
                            <span class="text-success float-left mr-1" v-if="data.tipoAditivo == 3 || data.tipoAditivo == 4">
                                <i class="fa fa-download fa-lg icon-button"
                                    title="Download"
                                    @click.stop="confirmarDownload(data)">
                                </i>
                            </span>
                        <span class="text-primary float-left mr-1">
                            <i
                                class="fa fa-unlock-alt fa-lg icon-button"
                                title="Ativar Aditivo"
                                @click.stop="confirmaAtivar(data.idAditivo)"
                                v-if="data.statusAditivo == 1"
                            ></i>
                        </span>
                    </template>
                    </app-tabela>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
    import BtnInserirAditivo from '../cadastro/aditivos/BtnInserirAditivo.vue'
    import BtnAtualizarAditivo from '../cadastro/aditivos/BtnAtualizarAditivo.vue'
    import BtnExcluirAditivo from '../cadastro/aditivos/BtnExcluirAditivo.vue'
    import ConveniosServicos from '../ConveniosServicos'

    export default {
        components: {
            BtnAtualizarAditivo,
            BtnExcluirAditivo,
            BtnInserirAditivo,
        },

        props: {
            convenio: {
                type: Object,
                default: () => ({})
            }
        },

        data() {
            return {
                erros: [],
                itensPorPagina: 5,
                aditivos: [],
                campos: [
                    {
                        key: 'objeto',
                        label: 'Objeto',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'tipoAditivoDesc',
                        label: 'Tipo',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'aditivo',
                        label: 'Aditivo',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'statusAditivoDesc',
                        label: 'Status',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'statusRmDesc',
                        label: 'Status RM',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'acoes',
                        label: 'Ações'
                    }
                ],

            }
        },

        methods:{
            atualizarLista(){
                this.$store.dispatch('addRequest')
                ConveniosServicos.obterPorId(this.convenio.idConvenio)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.aditivos = response.data.aditivos
                        }
                        else{
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            },

            confirmaAtivar(id){
                this.$swal({
                    title: 'Ativar Aditivo',
                    html: 'Deseja Ativar o Aditivo ?',
                    icon: 'success',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não'
                }).then(result => {
                    if (result.value) {
                        this.ativar(id)
                    }
                })
            },

            ativar(id){
                this.$store.dispatch('addRequest')
                ConveniosServicos.ativarAditivos(id)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$emit('atualizarConvenio')
                        }
                        else{
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            },

            exibirErro(erros) {
                this.erros = erros
            },

            permiteAtualizarAditivo(aditivo) {
                return this.$temAcessoView('CONV-ADT-01')
                    && aditivo.statusRm == 0
            },

            permiteDeletarAditivo(aditivo) {
                return this.$temAcessoView('CONV-ADT-02')
                    && aditivo.statusRm == 0
            },

            confirmarDownload(doc) {
            this.$swal({
                title: 'Download',
                html: `Confirma o Download do Documento ${doc.nomeArquivo}?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.download(doc)
                }
            })
        },

        download(aditivo) {
            this.$store.dispatch('addRequest')
            ConveniosServicos.downloadDocumentoAditivo(
                aditivo.idAditivo
            ).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro no Download!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.$download(response, aditivo.nomeArquivo)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
        },

        watch:{
            convenio(){
                if(this.convenio){
                    this.aditivos = this.convenio.aditivos
                }
            }
        },

        computed: {
            permiteInserirAditivo() {
                return this.$temAcessoView('CONV-ADT-01')
            },
        }
    }
</script>
